import { Component, HostListener, inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef } from 'ag-grid-community';
import { Router } from '@angular/router';
import { SalesOrderService } from '../../features/salesOrder/services/salesOrder.service';
import { ConfirmDialog } from '../../shared/components/confirm-dialog/confirm-dialog';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
// import { PermissionDirective } from '../../shared/directives/permissions.directive';
// import { Store } from '@ngrx/store';
// import * as selectPermissions from '../../core/permissions/permission.selector';
// import { Permission } from '../../shared/services/permissions';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';

@Component({
  selector: 'app-sales-order',
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    AgGridAngular,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
  ],
  templateUrl: './sales-order.component.html',
  styleUrl: './sales-order.component.scss',
})
export class SalesOrderComponent {
  public viewPortSize: boolean = false;
  private searchSubject = new Subject<string>();
  projectId: number;
  startDate: any;
  endDate: any;
  filter: any;
  page = 0;
  pageSize = 10;
  totalPages = 1;
  pageSizeOptions = [5, 10, 20, 50, 100];
  search: any;
  isExportOpen = false;
  fieldOptions = [
    { key: 'orderCode', label: 'Order Code' },
    { key: 'totalAmount', label: 'Total Amount' },
    { key: 'received', label: 'Received Amount' },
    { key: 'balance', label: 'Balance Amount' },
    { key: 'customerData.firstName', label: 'Customer Name' },
    { key: 'quoteData.quoteCode', label: 'Quote Code' },
  ];
  exportForm: FormGroup;
  exportFormat: string = 'pdf';
  exportLoading: boolean = false;
  dateRangeForm: FormGroup;
  columnDefs: (
    | {
        headerName: string;
        field: string;
        flex: number;
        cellRenderer?: undefined;
        floatingFilter?: undefined;
        filter?: undefined;
      }
    | {
        field: string;
        headerName: string;
        flex: number;
        cellRenderer: (params: string) => HTMLDivElement;
      }
  )[];
  dateFilter = (date: Date | null): boolean => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Remove time component
    return date ? date <= today : false;
  };

  constructor(
    private router: Router,
    private salesOrderService: SalesOrderService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private datePipe: DatePipe
  ) {
    this.exportForm = this.fb.group({
      fields: this.fb.array([]),
    });
  }

  rowData = [];

  ngOnInit() {
    const navigation = history.state;
    this.projectId = navigation.projectID || null;
    // const startDate = new Date();
    // const endDate = new Date();
    // const formatDate = (date: Date) => {
    //   return date.toLocaleDateString('en-CA');
    // };

    // this.filter = {
    //     startDate: formatDate(startDate),
    //     endDate: formatDate(endDate)
    //   },
    // }

    // this.fetchWorkOrders();
    this.fetchSalesOrders();

    this.dateRangeForm = this.fb.group({
      startDate: [''],
      endDate: [''],
    });

    this.searchSubject
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe((searchTerm) => {
        this.search=searchTerm
        this.fetchSalesOrders();
      });

    this.checkViewportSize();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkViewportSize();
  }

  checkViewportSize() {
    if (window.innerWidth > 1200) {
      this.viewPortSize = true;
    } else {
      this.viewPortSize = false;
    }
    this.setAGColumn();
  }

  setAGColumn() {
    this.columnDefs = [
      {
        headerName: 'Order Code #',
        field: 'orderCode',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Quote',
        field: 'quoteCode',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Customer Name',
        field: 'customerName',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Total Amount',
        field: 'totalAmount',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Received Amount',
        field: 'received',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Balance Amount',
        field: 'balance',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Status',
        field: 'status',
        flex: this.viewPortSize ? 1 : 0,
        cellRenderer: (params: any): HTMLDivElement => {
          const value = params.value || '';
          const span = document.createElement('span');

          let color = '';
          switch (value.toLowerCase()) {
            case 'new':
              color = 'blue';
              break;
            case 'pending':
              color = 'orange';
              break;
            case 'confirmed':
              color = 'purple';
              break;

            case 'completed':
              color = 'green';
              break;
            case 'rejected':
              color = 'red';
              break;
            default:
              color = 'black';
          }

          span.style.color = color;
          span.style.fontWeight = '500';
          span.innerText = value;

          // 👇 Required: Return a proper HTMLDivElement
          const div = document.createElement('div');
          div.appendChild(span);
          return div;
        },
      },
      // {
      //   field: 'action',
      //   headerName: 'Actions',
      //   flex: this.viewPortSize ? 1 : 0,
      //   cellRenderer: (params: any) => {
      //     const container = document.createElement('div');
      //     container.style.display = 'flex';
      //     container.style.alignItems = 'center';
      //     container.style.gap = '20px';

      //     const editIcon = document.createElement('img');
      //     editIcon.src = 'assets/images/icons/icon-edit.svg';
      //     editIcon.style.cursor = 'pointer';
      //     editIcon.setAttribute('data-action', 'edit');
      //     container.appendChild(editIcon);
      //     this.store
      //       .select(selectPermissions.hasPermission('7', Permission.Edit))
      //       .subscribe((canEdit) => {
      //         if (canEdit) {
      //           container.appendChild(editIcon);
      //         }
      //       });
      //     container.appendChild(editIcon);
      //     const deleteIcon = document.createElement('img');
      //     deleteIcon.src = 'assets/images/icons/icon-delete.svg';
      //     deleteIcon.style.cursor = 'pointer';
      //     deleteIcon.setAttribute('data-action', 'delete');

      //     // if(this.profileName === 'admin'){
      //     //   container.appendChild(deleteIcon);
      //     // }
      //     this.store.select(selectPermissions.hasPermission('7', Permission.Delete)).subscribe((canDelete) => {
      //       if (canDelete) {
      //         container.appendChild(deleteIcon);
      //       }
      //     });

      //     return container;
      //   },
      //   floatingFilter: false,
      //   filter: false,
      // },
    ];
  }

  onSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    this.pageSize = 10;
    this.page = 0;
    this.searchSubject.next(input.value);
  }

  private fetchSalesOrders(pageSize: number = 10) {
    if (pageSize) {
      this.pageSize = pageSize;
    }
    const skip = this.page * this.pageSize;
    const input = {
      search: this.search,
      limit: this.pageSize,
      // advancedSearch: this.advancedSearch,
      startDate:this.startDate,
      endDate: this.endDate,
      skip,
    }
    this.salesOrderService.findAllOrdersWithPagination(input).subscribe({
      next: (orders: any) => {
        this.totalPages = Math.ceil(
          (orders?.total || orders?.orders?.length) / this.pageSize
        );        
        // Sort the designations by 'id' in descending order so the newest branch comes first
        this.rowData = (orders?.orders || [])
          .map((order: any) => {
            return {
              orderCode: order?.orderCode || '--',
              quoteCode: order?.quoteData?.quoteCode || '--',
              customerName:
                `${order.customerData?.firstName || ''} ${
                  order.customerData?.lastName || ''
                }` || '--',
              id: order?.id || '--',
              totalAmount: order?.totalAmount != null ? `AED ${Number(order.totalAmount).toFixed(2)}` : '--',
              received: order?.received != null ? `AED ${Number(order.received).toFixed(2)}` : '--',
              balance: order?.balance != null ? `AED ${Number(order.balance).toFixed(2)}` : '--',
              status: order?.status || '--',
            };
          })
          .sort((a: any, b: any) => b.id - a.id);
      },
      error: (error: any) => {
        // this.error = error;
        // this.loading = false;
      },
    });
  }

  nextPage() {
    if (this.page + 1 < this.totalPages) {
      this.page++;
      this.fetchSalesOrders(this.pageSize);
    }
  }

  prevPage() {
    if (this.page > 0) {
      this.page--;
      this.fetchSalesOrders(this.pageSize);
    }
  }

  onPageSizeChange(event: Event): void {
    const newSize = Number((event.target as HTMLSelectElement).value);
    console.log('New Page Size:', newSize);
    this.pageSize = newSize; // ✅ Correctly update pageSize
    this.page = 0; // ✅ Reset to first page
    this.fetchSalesOrders(this.pageSize); // ✅ Use new pageSize
  }


  onCellClicked(params: any) {
    const id = params.data?.id;
    if (
      params.column.colId === 'action' &&
      params.event.target.dataset.action
    ) {
      let action = params.event.target.dataset.action;

      if (action === 'edit') {
        this.onEdit(id);
      } else if (action === 'delete') {
        this.onConfirmDelete(id);
      }
    } else {
      this.router.navigate([`sales-order/order-flow-admin-view`], {
        queryParams: { id: id },
      });
    }
  }

  onConfirmDelete(id: number): void {
    const dialogRef = this.dialog.open(ConfirmDialog);
    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.onDelete(id);
      }
    });
  }
  onDelete(id: any) {
    this.salesOrderService.removeWorkOrder(id).subscribe({
      next: (result) => {
        if (result) {
          this.toastr.success('Sales Order deleted successfully', 'Success');
          this.fetchSalesOrders();
        }
      },
      error: (error) => {
        this.toastr.error(error, 'Error');
      },
    });
  }

  onDateChange(event: any, type: string) {
    const formattedDate = this.datePipe.transform(event.value, 'yyyy-MM-dd');
    if (type === 'start') {
      this.startDate = formattedDate;
    } else if (type === 'end') {
      this.endDate = formattedDate;
    }
    if (this.startDate != null && this.endDate != null) {
      // this.filter = { dateRange: { startDate: this.startDate, endDate: this.endDate } };
      this.fetchSalesOrders();
    }
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
  }

  onClear(){
    this.startDate = null;
    this.endDate = null;
    this.dateRangeForm.reset();
    this.fetchSalesOrders();
  }

  toggleExport(event: MouseEvent) {
    event.stopPropagation();
    this.isExportOpen = !this.isExportOpen;
  }

  onFieldCheckboxChange(event: any, fieldName: string) {
      const fieldsArray: FormArray = this.exportForm.get('fields') as FormArray;
  
      if (event.target.checked) {
        fieldsArray.push(new FormControl(fieldName));
      } else {
        const index = fieldsArray.controls.findIndex(
          (control) => control.value === fieldName
        );
        if (index >= 0) {
          fieldsArray.removeAt(index);
        }
      }
    }

    exportOrders() {
      const selectedFields = this.exportForm.value.fields;
  
      if (selectedFields.length === 0) {
        this.toastr.error('Please select at least one field to export.');
        return;
      }
  
      let exportObservable;
      const input = {
        search: this.search,
      }
      // switch (this.exportFormat) {
      //   case 'pdf':
      //     exportObservable =
      //       this.projectService.exportProjectsToPDF(input, selectedFields);
      //     break;
      //   case 'csv':
      //     exportObservable =
      //       // this.pr/ojectService.exportProjectsToCSV(input, selectedFields);
      //     break;
      //   default:
      //     this.toastr.error('Invalid export format selected.');
      //     return;
      // }
  
      this.exportLoading = true;
      // Call the export service method
      // exportObservable.subscribe({
      //   next: (response: Blob) => {
      //     this.exportLoading = false;
      //     // this.getFile(response, this.exportFormat);
      //   },
      //   error: (error) => {
      //     this.exportLoading = false;
      //     this.toastr.error(
      //       'Failed to export employees. Please try again.'
      //     );
      //   },
      // });
    }

  onEdit(id: any) {
    this.router.navigate([`/sales-order/sales-order-edit/${id}`]);
  }

  readonly dialog = inject(MatDialog);

  openDialog() {
    const dialogRef = this.dialog.open(UploadWorkOrderDialog);
  }

  public defaultColDef: ColDef = {
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  };
  public rowSelection: 'single' | 'multiple' = 'multiple';
  public paginationPageSize = 10;
  public paginationPageSizeSelector: number[] | boolean = [10, 25, 50];
  public themeClass: string = 'ag-theme-quartz';
}

@Component({
  selector: 'upload-sales-order-dialog',
  templateUrl: 'upload-sales-order-dialog.html',
  styleUrls: ['./sales-order.component.scss'],
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
})
export class UploadWorkOrderDialog {
  file: any = null;

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      console.log('Selected file:', file);
      this.file = file;
    }
  }
}
